import React, { useState, useEffect } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const SlideShow = ({ moduleJson }) => {
  const [sliedShow, setSlideShow] = useState(false);
  useEffect(() => {
    if (moduleJson.length > 0) setSlideShow(true);
    else setSlideShow(false);
  }, [moduleJson]);
  return (
    <React.Fragment>
      {sliedShow ? (
        <Slide>
          {moduleJson.map((banner) => (
            <div className="each-slide-effect" key={banner.type}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={banner.description}
                className="wp-link"
              >
                <img src={banner.code} alt={banner.title}></img>
              </a>
            </div>
          ))}
        </Slide>
      ) : null}
    </React.Fragment>
  );
};
export default SlideShow;
